(function () {
    'use strict';

    angular
        .module('app.paymentGateways')
        .controller('PaymentGatewayDetailsController', PaymentGatewayDetailsController);

    PaymentGatewayDetailsController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function PaymentGatewayDetailsController($state, $stateParams, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.preventDelete = preventDelete;
        vm.providerChange = providerChange;
        vm.selectedProviderSettings = [];
        vm.paymentProviderSettings = [];
        vm.numberOfUses = 0;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItem(), getPaymentProviders(), getLicenseInfo(), getNumberOfUses()];
            return common.$q.all(promises).then(function (data) {
                providerChange(true);
            }, function (error) { });
        }

        function getNumberOfUses() {
            if ($stateParams.id !== '') {
                return dataservice.getItems('api/PaymentGateways/CountOfUses/' + $stateParams.id).then(function (response) {
                    vm.numberOfUses = response.data.NumberOfUses;
                }, function (error) { });
            }

        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                if (vm.licenseInfo.NumberOfPaymentTemplatesLicensed < vm.licenseInfo.NumberOfPaymentTemplatesInUse) {
                    $state.go('404');
                }
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("paymentgateways.list");
        }

        function preventDelete() {
            if ($stateParams.id === '' || vm.numberOfUses > 0) {
                return true;
            }

            return false;
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Payment Gateway')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/PaymentGateways/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function getPaymentProviders() {
            return dataservice.getItems('api/PaymentGateways/GetLookups').then(function (response) {
                
                vm.paymentProviders = response.data.PaymentProviders;
                vm.paymentProviderSettings = response.data.ProviderSettings;
            }, function (error) { });
        }

        function providerChange(isLoading) {
            if (vm.item.PaymentProviderUId != '') {
                vm.selectedProviderSettings = [];
                if (!isLoading) {
                    vm.item.Settings = [];
                }

                for (var i = 0; i < vm.paymentProviderSettings.length; i++) {
                    var onSetting = vm.paymentProviderSettings[i];
                    if (onSetting.PaymentProviderUId == vm.item.PaymentProviderUId) {
                        
                        for (var j = 0; j < vm.item.Settings.length; j++) {
                            if(vm.item.Settings[j].PaymentProviderSettingUId == onSetting.ID) {
                                onSetting.value = vm.item.Settings[j].SettingValue;
                            }
                        }
                        if (onSetting.FieldType == 1 && !onSetting.value) {
                            onSetting.value = 0;
                        }
                        vm.selectedProviderSettings.push(onSetting);
                    }
                }
            }
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '') {
                vm.item = {};
                vm.item.Settings = [];
                common.setAuditInfo(vm.item);

                return vm.item;
            }

            return dataservice.getItem("api/PaymentGateways/" + val)
                .then(function (response) {
                    if (response) {
                        vm.item = response.data;
                        common.setAuditInfo(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function save() {
            vm.isSaving = true;

            vm.item.Settings = [];
            for (var i = 0; i < vm.selectedProviderSettings.length; i++) {
                vm.item.Settings.push({ "PaymentProviderSettingUId": vm.selectedProviderSettings[i].ID, "SettingValue": vm.selectedProviderSettings[i].value });
            }
            dataservice.saveItem('api/PaymentGateways', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
